<script lang="ts" context="module">
	import { getClassicWebUrl, getCurrentUser } from "../currentUser";
	import ToolbarItem from "./ToolbarItem.svelte";
	import CreateNewsletterButton from "../CreateNewsletterButton.svelte";
	import ToolbarMenuItem from "./ToolbarMenuItem.svelte";
	import ToolbarMobileMenuContent from "./ToolbarMobileMenu.svelte";
	import { page } from "$app/stores";
	import Avatar from "../Avatar.svelte";
	import Pluralize from "pluralize";
</script>

<script lang="ts">
	const CLASSIC_WEB_URL = getClassicWebUrl();
	const user = getCurrentUser();

	// TODO: Implement "integrationEditorMode" after moving the editor to the new-app (see "toolbar_button_integration_editor_mode" for reference)
	const integrationEditorMode = false;

	$: routeId = $page.route.id;

	const newNewsletterUrl = user.caps.feature__new_app_newsletter_wizard
		? new URL("/newsletters/new?s=toolbar-button", document.location.origin)
		: new URL(`${CLASSIC_WEB_URL}/app/pages/new_wizard?s=toolbar-button`);

	const accountUrl = user.caps.feature__new_app_account
		? "/account?s=toolbar-mobile-menu"
		: `${CLASSIC_WEB_URL}/app/users/account?s=toolbar-mobile-menu`;
</script>

{#if !$page.data.overrideToolbarContent}
	<CreateNewsletterButton url={newNewsletterUrl} />

	<ToolbarItem title="Help" link="https://help.smore.com?s=toolbar-button" openInNewTab={true} visible="sm" />
{/if}

<!-- Account button -->
<ToolbarItem link="#" visible="sm" menuBehavior="opensOnClick" menuPosition="bottom-right" active={routeId === "/(app)/account"}>
	<div class="relative flex items-center rounded p-2.5 text-14 font-normal hover:bg-gray-100">
		<div class="mr-2">
			<Avatar url={user.picture} size="34px" />
		</div>
		<span class="hidden md:flex"> Account </span>
		<span class="material-icons ml-1 text-16 text-nxgray-400"> expand_more</span>
	</div>

	<div slot="menu" class="w-full">
		<div class="mx-[5px] flex items-start justify-start px-2 py-[7px] leading-tight">
			<Avatar url={user.picture} size="42px" />
			<div class="m-0 ml-2.5 flex w-44 flex-col items-start p-0 text-white">
				<h2 class="text-16 font-bold text-orange-100">{user.name}</h2>
				<div class="mt-[5px] flex flex-col items-start">
					{#if user.organization}
						<div class="text-left text-14 font-medium">
							{user.organization.name}
						</div>
					{/if}
					<span class="text-13 font-normal opacity-70">
						{#if user.organization}
							Smore for Teams
						{:else}
							<p>
								{user.plan.title}
								{#if !user.isPro && !user.credits.newsletters.isUnlimited}
									({Pluralize("newsletter", user.credits.newsletters.balance, true)} left)
								{/if}
							</p>
						{/if}
					</span>
				</div>
				{#if !user.isPro}
					<a
						class="clickable mt-4 rounded bg-orange-600 px-1 py-0.5 text-11 font-bold uppercase tracking-wider text-white hover:bg-orange-500"
						href={`${CLASSIC_WEB_URL}/upgrade?ur=toolbar-account-menu&re=True`}>
						Upgrade
					</a>
				{/if}
			</div>
		</div>
		<hr class="my-[5px] h-px w-full border-t border-white opacity-15" />
		<div
			class="flex w-full flex-col px-[5px] text-14 [&>a>.material-icons]:font-bold
												[&>a>.material-icons]:text-nxgray-300 [&>a]:transition-all [&>a]:duration-150 [&>a]:ease-linear">
			<ToolbarMenuItem title="Account & billing" url={accountUrl} />
			<ToolbarMenuItem title="Logout" url="{CLASSIC_WEB_URL}/app/users/logout" />
		</div>
	</div>
</ToolbarItem>

<ToolbarItem link="#" visible="upto-sm" menuBehavior="opensOnHover" menuPosition="full-width" menuChevron={false}>
	<span slot="icon" class="material-icons text-nxgray-400"> menu</span>
	<div slot="menu" class="h-screen w-full px-4" let:closeMenu>
		<ToolbarMobileMenuContent {user} on:click={closeMenu} />
	</div>
</ToolbarItem>
